import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui'; // Importa Element UI
import 'element-ui/lib/theme-chalk/index.css'; // Importa los estilos de Element UI
import DashboardPlugin from './plugins/dashboard-plugin';
import router from './routes/router';

Vue.use(ElementUI); // Usa Element UI

Vue.use(DashboardPlugin);

new Vue({
  el: '#app',
  render: h => h(App),
  router
});